import React from 'react';
import { Button } from '@naf-simba/elements-buttons';
import { resolveLinkProps } from '@lib/resolveLinkProps';
import useSelector from '@redux/typedHooks';
import { useTrackCTA } from '@utils/Tracking/CtaClick/TrackCtaClick';
import { mapSimbaVariant, type LegacyButtonVariant } from '@utils/simba';
import { useTrackPromotion } from '@hooks/useTrackPromotion';
import { getPromotionEventTrackingData } from '@utils/Tracking/Promotion/getPromotionEventTrackingData';

interface CtaButtonLinkSerializerProps {
  value: { text: string; url: string; variant?: LegacyButtonVariant };
}

export const CtaButtonLink = ({ value: { text, url, variant } }: CtaButtonLinkSerializerProps) => {
  const baseUrl = useSelector((state) => state.application.baseUrl);
  const trackCTA = useTrackCTA();

  const linkProps = resolveLinkProps({ url, baseUrl });
  const buttonVariant = mapSimbaVariant(variant);
  const urlToCheck = 'to' in linkProps ? (linkProps as { to: string }).to : url;
  const promotion = getPromotionEventTrackingData(text, urlToCheck);
  const shouldTrackPromotion = Boolean(promotion);
  const { wrapperRef, trackSelectPromotion } = useTrackPromotion({
    creative_slot: 'block-content',
    creative_name: `CTA | ${buttonVariant.variant} | ${text}`,
    promotion_id: promotion?.promotion_id,
    promotion_name: promotion?.promotion_name,
  });

  return (
    <div ref={shouldTrackPromotion ? wrapperRef : undefined} className="cta-button-body">
      <Button
        onClick={() => {
          if (shouldTrackPromotion) {
            trackSelectPromotion();
          }
          trackCTA({ cta_position: 'content', text, url });
        }}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...linkProps}
        variant={buttonVariant.variant}
        color={buttonVariant.color}
        shade={buttonVariant.shade}
        className="CtaButton"
        width="fit-content"
      >
        {text}
      </Button>
    </div>
  );
};
